export default __webpack_public_path__ + "static/media/fitfactory.c043517b.png";